/* istanbul ignore file */
import React from 'react';

import { isReseller } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { isGodSelector } from '@lumapps/user/ducks/selectors';

import {
    ResellerSideNavigation as ResellerSideNavigationComponent,
    ResellerSideNavigationProps,
} from './ResellerSideNavigation';

type ConnectedResellerSideNavigationProps = Omit<ResellerSideNavigationProps, 'isAllowed'>;

export const ResellerSideNavigation: React.FC<ConnectedResellerSideNavigationProps> = (props) => {
    const isGod = useSelector(isGodSelector);
    const isResellerUser = useSelector((state: BackOfficeStore) => isReseller(state));
    const isAllowed = isGod && isResellerUser;

    return <ResellerSideNavigationComponent {...props} isAllowed={isAllowed} />;
};

ResellerSideNavigation.displayName = 'ResellerSideNavigationConnected';
